import { visserApi } from './visserApi';
import { convertModelToFormData } from './helpers';
const getAllDebtors = async () => {
    return await visserApi.get('debtor/GetAll');
};
const createDebtor = async (createdQuotation) => {
    return await visserApi.post('debtor/Create', createdQuotation);
};
const getDebtorNumber = async () => {
    return await visserApi.get('debtor/GetDebtorNumber');
};
const updateDebtor = async (updateQuotationAmount) => {
    return await visserApi.put(`debtor/Update`, updateQuotationAmount);
};
const getAllApprovedDebtors = async (request) => {
    const filter = `&filter=${request.filter ? request.filter : ''}`;
    const SortColumn = `&SortColumnKey=${request.sortColumnKey}`;
    const SortDirection = `&SortDirection=${request.sortDirection}`;
    const columnWiseFilter = request || {};
    return visserApi.post(`debtor/GetAllApprovedDebtors?PageNumber=${request.pageNumber}&PageSize=${request.pageSize}${filter}${SortColumn}${SortDirection}`, columnWiseFilter);
};
const getDebtorById = async (debtorId) => {
    return await visserApi.get(`debtor/GetById/${debtorId}`);
};
const getAllPendingDebtors = async (request) => {
    const filter = `&filter=${request.filter ? request.filter : ''}`;
    const SortColumn = `&SortColumnKey=${request.sortColumnKey}`;
    const SortDirection = `&SortDirection=${request.sortDirection}`;
    const columnWiseFilter = request || {};
    return visserApi.post(`debtor/GetAllPendingDebtors?PageNumber=${request.pageNumber}&PageSize=${request.pageSize}${filter}${SortColumn}${SortDirection}`, columnWiseFilter);
};
const createContactPerson = async (contactPerson) => {
    return await visserApi.post('debtor/CreateContact', contactPerson);
};
const getContactsByDebtorId = async (debtorId) => {
    return await visserApi.get(`debtor/GetContactsByDebtorId/${debtorId}`);
};
const getContactById = async (id) => {
    return await visserApi.get(`debtor/GetContactById/${id}`);
};
const updateContact = async (updateContact) => {
    return await visserApi.put(`debtor/UpdateContact/${updateContact.id}`, updateContact);
};
const deleteContactById = async (id) => {
    return await visserApi.post(`debtor/DeleteContactById/${id}`);
};
const deleteDebtorById = async (id) => {
    return await visserApi.delete(`debtor/Delete/${id}`);
};
const getAllAttachmentsByDebtorId = async (creditorId) => {
    return await visserApi.get(`debtor/GetAllAttachmentsByDebtorId/${creditorId}`);
};
const addAttachmentsByDebtorId = (fileUploaded) => {
    const formData = convertModelToFormData(fileUploaded);
    return visserApi.postForm('debtor/UploadDebtorAttachment', formData);
};
const deleteDebtorAttachment = (attachmentId) => {
    return visserApi.delete(`debtor/DeleteDebtorAttachmentById/${attachmentId}`);
};
const approveDebtorByDebtorId = async (debtorId) => {
    return await visserApi.get(`debtor/ApproveDebtorById/${debtorId}`);
};
const createDebtorSpecification = async (createDebtorSpecification) => {
    return await visserApi.post(`DebtorSpecification/Create`, createDebtorSpecification);
};
const getAllDebtorSpecificationbyDebtorId = async (debtorId) => {
    return await visserApi.get(`DebtorSpecification/GetByDebtorId/${debtorId}`);
};
const getDebtorSpecificationbyId = async (id) => {
    return await visserApi.get(`DebtorSpecification/GetById/${id}`);
};
const updateDebtorSpecification = async (updateDebtorSpecification) => {
    return await visserApi.post(`DebtorSpecification/Update`, updateDebtorSpecification);
};
const deleteDebtorSpecification = (id) => {
    return visserApi.delete(`DebtorSpecification/Delete/${id}`);
};
const disapproveDebtorByDebtorId = async (debtorId) => {
    return await visserApi.get(`debtor/DisapproveDebtorById/${debtorId}`);
};
const getDebtorLinksCountById = async (debtorId) => {
    return await visserApi.get(`debtor/getDebtorLinksCountById/${debtorId}`);
};
const getAllDisapprovedDebtors = async (request) => {
    const filter = `&filter=${request.filter ? request.filter : ''}`;
    const SortColumn = `&SortColumnKey=${request.sortColumnKey}`;
    const SortDirection = `&SortDirection=${request.sortDirection}`;
    const columnWiseFilter = request || {};
    return visserApi.post(`debtor/GetAllDisapprovedDebtors?PageNumber=${request.pageNumber}&PageSize=${request.pageSize}${filter}${SortColumn}${SortDirection}`, columnWiseFilter);
};
const DebtorsApi = {
    createDebtor,
    getAllDebtors,
    getDebtorNumber,
    updateDebtor,
    getAllApprovedDebtors,
    getDebtorById,
    getAllPendingDebtors,
    createContactPerson,
    getContactsByDebtorId,
    getContactById,
    updateContact,
    deleteContactById,
    deleteDebtorById,
    getAllAttachmentsByDebtorId,
    addAttachmentsByDebtorId,
    deleteDebtorAttachment,
    approveDebtorByDebtorId,
    createDebtorSpecification,
    getAllDebtorSpecificationbyDebtorId,
    getDebtorSpecificationbyId,
    updateDebtorSpecification,
    deleteDebtorSpecification,
    disapproveDebtorByDebtorId,
    getDebtorLinksCountById,
    getAllDisapprovedDebtors
};
export default DebtorsApi;
